import * as React from 'react';
import { ControlHeader } from '../../atoms';
import { st, classes } from './ControlBase.st.css';
import './ControlBase.responsive.st.css';
const Divider = ({ divider }) => (React.createElement("div", { "data-hook": "control-base-divider", "data-type": divider, className: st(classes.divider, { size: divider }) }));
const ControlBase = ({ dataHook, children, controlHeaderProps = {}, alignment = 'vertical', containerClassName, divider, }) => {
    const [hoverControl, setHoverControl] = React.useState(false);
    const controlHeaderHasContent = () => Boolean(controlHeaderProps?.title ||
        controlHeaderProps?.tooltipInfo?.text ||
        controlHeaderProps?.prefix ||
        controlHeaderProps?.suffix);
    const hasHeader = controlHeaderHasContent();
    return (React.createElement("div", { "data-hook": dataHook, tabIndex: 0, onFocus: () => setHoverControl(true), className: classes.controlWrapper },
        React.createElement("div", { className: st(classes.root, {
                hasHeader,
                alignment,
            }, containerClassName), onMouseEnter: () => setHoverControl(true), onMouseLeave: () => setHoverControl(false), onBlur: () => setHoverControl(false) },
            hasHeader && (React.createElement(ControlHeader, { ...controlHeaderProps, showInfo: hoverControl })),
            children),
        divider && React.createElement(Divider, { divider: divider })));
};
export default ControlBase;
//# sourceMappingURL=ControlBase.js.map